import api from "services/api";

// Get all projects
export const getProjects = async () => {
  return api.get("/v1/api/projects/get");
};

// Create a new project
export const createProject = async (projectData) => {
  return api.post("/v1/api/projects/create", projectData);
};

// Update a project
export const updateProject = async (projectId, projectData) => {
  return api.patch(`/v1/api/projects/update/${projectId}`, projectData);
};

// Delete a project
export const deleteProject = async (projectId) => {
  return api.delete(`/v1/api/projects/delete/${projectId}`);
};
